module.exports = __webpack_public_path__ + "img/ico-v.11e755ac.svg";